module.exports = "<div class=\"SocialLinks\">\n  <ul>\n    <li ng-repeat=\"socialLink in ctrl.socialLinks\">\n      <a target=\"_blank\" ng-href=\"{{socialLink.url}}\" class=\"SocialLinks-bubble\" ng-class=\"'SocialLinks-bubble--' + socialLink.name\">\n        <i class=\"Icon\" ng-class=\"'Icon-' + socialLink.name\"></i>\n      </a>\n    </li>\n  </ul>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/common/social_links/social_links.html
// module id = 335
// module chunks = 24